import { useState, useEffect } from 'react';
import 'cross-fetch/polyfill';
import { DeliveryService } from '@ynap/api-utils';
import { raygun } from '@ynap/clientside-monitoring';
import { useAppState, useConfig } from '@ynap/immutables-provider';

const reportToRaygun = (message) =>
    raygun.helpers.agent('send', {
        error: message,
        tags: ['pdp-delivery-info'],
    });

const configSelector = (config) => ({
    baseUrl: config.global.services.commerce.baseUrl,
    clientId: config.global.services.commerce.clientId,
    brandId: config.global.application.brandId,
});

export const useStaticDeliveryInfo = (config) => {
    const [isLoading, setIsLoading] = useState(false);
    const [responseData, setResponseData] = useState([]);
    const [error, setError] = useState(null);
    const { baseUrl, brandId, clientId } = config || useConfig(configSelector);
    const { country, langId } = config || useAppState();

    const handleError = (message) => {
        reportToRaygun(message);
        setIsLoading(false);
        setError(message);
    };

    const handleBadResponse = (res) => {
        if (!res.ok) {
            handleError(res.statusText);
            throw new Error(res.statusText);
        }
        return res;
    };

    // TODO: remove polyfill when we stop supporting IE11 or we have a better polyfill solution
    const polyfillAbortController = () => (AbortController ? new AbortController() : { signal: undefined, abort: () => {} });

    useEffect(() => {
        const abortController = polyfillAbortController();
        const signal = abortController.signal;

        if (responseData.length === 0) {
            setIsLoading(true);

            const fetchShippingModes = async () => {
                const requestOptions = signal && { signal };
                const options = langId && { langId };
                const request = DeliveryService.getStaticDeliveryInfo({ baseUrl, brandId, clientId, country, requestOptions, options });

                const modes = await fetch(request)
                    .then(handleBadResponse)
                    .then((res) => res.json())
                    .catch(handleError);

                if (modes) {
                    setIsLoading(false);
                    setResponseData(modes.storeShippingModes);
                }
            };

            fetchShippingModes();
        }

        return () => abortController.abort();
    }, [baseUrl, brandId, clientId, country]);

    return { error, responseData, isLoading };
};
